import { createApp } from 'vue';
import PoolingPortal from './PoolingPortal.vue';
import router from './router';
import store from './store';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap'
import '@/assets/global.css';

createApp(PoolingPortal).use(router).use(store).mount('#PoolingPortal')
